import $ from 'jquery';

$(function () {
    ymaps.ready(function () {
        const map = new ymaps.Map('app-shops-map', {
            center: [52.969234, 36.035452],
            zoom: 10
        });
        const $shopItems = $('.app-shop-item');

        // добавим все точки на карту
        $shopItems.each(function () {
            const placemark = new ymaps.Placemark([$(this).data('lng'), $(this).data('lat')], {
                balloonContent: `
                    <strong>${$(this).data('name')}</strong><br>
                    ${$(this).data('address')}
                `
            }, {
                preset: 'islands#darkOrangeIcon',
                iconColor: '#d3983b'
            });
            map.geoObjects.add(placemark);
        });

        $('.app-city-item').on('click', function () {
            map.setCenter([$(this).data('lng'), $(this).data('lat')]);
        });

        $shopItems.on('click', function (e) {
            e.preventDefault();
            $shopItems.removeClass('active');
            $(this).addClass('active');
            map.setCenter([$(this).data('lng'), $(this).data('lat')], 16);
        });
    });
});

